import { JobPosition } from '@features/hireflixJob';
import { Close } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';

import { DeleteIcon } from '../../../vectors/index';
import { useHireflixDeleteVideoInterview } from '../hooks/useHireflixDeleteVideoInterview';

type HireflixDeleteVideoInterviewModalProps = {
  open: boolean;
  onClose: () => void;
  selectedJob: JobPosition | null;
  templateId: number;
};

const HireflixDeleteVideoInterviewModal: FC<
  HireflixDeleteVideoInterviewModalProps
> = ({ open, onClose, selectedJob, templateId }) => {
  const [errorText, setErrorText] = useState('');
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);

  const { deleteVideoInterview, isDeleteVideoInterviewLoading } =
    useHireflixDeleteVideoInterview({
      setErrorText,
    });

  const handleDelete = () => {
    if (!selectedJob) return;

    deleteVideoInterview(
      {
        job_id: selectedJob.id,
        template_id: templateId,
      },
      {
        onSuccess: () => {
          setShowSuccessSnackbar(true);
          onClose();
        },
      },
    );
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <IconButton
            sx={{ position: 'absolute', top: 5, right: 5 }}
            onClick={onClose}
          >
            <Close />
          </IconButton>
          <br />
          <DeleteIcon />
          <br />
          <Typography variant="h4" sx={{ p: 3, mb: 2 }}>
            Are you sure you want to delete &apos;
            <strong>{selectedJob?.s_title}</strong>&apos; job?
          </Typography>
        </DialogTitle>

        <DialogContent>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <Stack spacing={2} mb={2}>
            <LoadingButton
              variant="contained"
              color="error"
              onClick={handleDelete}
              loading={isDeleteVideoInterviewLoading}
            >
              Delete
            </LoadingButton>
            <Button
              disabled={isDeleteVideoInterviewLoading}
              variant="contained"
              color="secondary"
              onClick={onClose}
            >
              Cancel
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>

      <Snackbar
        open={showSuccessSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSuccessSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setShowSuccessSnackbar(false)}
          severity="success"
          sx={{ width: '100%' }}
        >
          Job deleted successfully.
        </Alert>
      </Snackbar>
    </>
  );
};

export default HireflixDeleteVideoInterviewModal;
